import script from "./BasePageTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePageTabs.vue?vue&type=script&setup=true&lang=js"

import "./BasePageTabs.vue?vue&type=style&index=0&id=7efbcfe6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efbcfe6"]])

export default __exports__